/**
* 處理點擊上一頁邏輯
* @param {String} fallbackUrl - fallback onback url
* @return {Undefined}
*/
export default function nativeOnBack({ fallbackUrl }) {
  const referrerHostname = /^http/.test(document.referrer) && new URL(document.referrer).hostname
  const currentHostname = new URL(window.location).hostname
  const goToFallbackUrl = () => {
    fallbackUrl
      ? window.location.assign(fallbackUrl)
      : window.history.back()
  }

  if (referrerHostname === currentHostname) {
    window.history.back()
    setTimeout(goToFallbackUrl, 300) // 避免開新分頁時，browser 沒有上一頁的情況
  } else {
    goToFallbackUrl()
  }
}
